import React from 'react';
import ReactDom from 'react-dom';
import { observer } from 'mobx-react';
import { api } from '../../config';

// Helpers
import { getPath } from '../../helpers/helpers';

const LoadMore = observer(class LoadMore extends React.Component {
  constructor() {
    super();
    this.loadFunction = this.loadFunction.bind(this);
    this.cleanUrl = this.cleanUrl.bind(this);
  }

  componentWillMount() {
    this.state = {
      clicked: false,
      url: this.props.url || null,
      done: false
    }
  }

  componentWillUpdate(nextProps) {
    if(!this.state.url) {
      this.setState({
        url: nextProps.url
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.url !== this.state.url) {
      this.setState({
        url: nextProps.url
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(!nextProps.url || (nextProps.url === this.state.url && nextProps.url !== nextState.url)) {
      return false;
    }

    return true;
  }
  cleanUrl = (url) => {
    return url.replace('/v1', '').replace('&appointmentDate=null', '');
  }

  loadFunction() {
    const { SessionStore } = this.props.store;
    const {onLoad, resultsName} = this.props;
    if(!this.state.done) {
      api.get(this.state.url)
        .then(response => {
          if(!this.props.dataFormat) {
            Array.prototype.push.apply(this.props.group, resultsName ? response.data[resultsName].results : response.data.results);
            if(onLoad){
              onLoad(this.props.group);
            }
          } else {
            this.props.dataSet(
              this.props.dataFormat(response.data.results)
            );
          }

          this.setState({
            clicked: false
          });
          if(resultsName){
            if(response.data[resultsName].next){
              let nextUrl = this.cleanUrl(getPath(response.data[resultsName].next));
  
              if(nextUrl !== this.state.url) {
                this.setState({
                  url: nextUrl
                });
              } else {
                this.setState({
                  url: null
                });
              }
            }
          else {
            this.setState({
              url: null,
              done: true
            });
          }
          }
          else{
            if(response.data.next) {
              // API returns a url with a different domain for the next link
              // so create an anchor element and set its href to the next link
              // and then grab the pathname and query from that
              console.log(response.data.next);
              let nextUrl = this.cleanUrl(getPath(response.data.next));

              if(nextUrl !== this.state.url) {
                this.setState({
                  url: nextUrl
                });
              } else {
                this.setState({
                  url: null
                });
              }
            }
          else {
              this.setState({
                url: null,
                done: true
              });
            
            }
        }
        })
        .catch(error => {
          SessionStore.throwError(error);
        });
    }
  }

  isVisible() {
    if(this.refs.button) {
      const button = ReactDom.findDOMNode(this.refs.button).getBoundingClientRect();

      return button.top <= window.innerHeight;
    }
  }

  render() {
    const _this = this;
    const { SessionStore } = this.props.store;

    if(!this.props.drawer && !this.props.wrapper) {
      window.addEventListener('scroll', function(){
        if(_this.isVisible()) {
          _this.setState({
            clicked: true
          }, function(){
            _this.loadFunction();
          });
        }
      });
    } else if(this.props.wrapper) {
      const _this = this;
      let wrapper = null;

      setTimeout(function(){
        wrapper = document.querySelector(_this.props.wrapper);

        if(wrapper) {
          wrapper.addEventListener('scroll', function(){
            if(_this.isVisible()) {
              _this.setState({
                clicked: true
              }, function(){
                _this.loadFunction();
              });
            }
          });
        }
      });
    } else if(this.props.tableContainer) {

      const tableContainer = document.querySelector('.table-container');

      if(tableContainer) {
        tableContainer.addEventListener('scroll', function(){

          if(_this.isVisible()) {

                _this.setState({
                  clicked: true
                }, function() {
                  _this.loadFunction();
                });
              }
        });
      }
    } else if(this.props.drawer) {
      const drawer = document.querySelector('.drawer');

      if(drawer) {
        drawer.addEventListener('scroll', function(){
          if(_this.isVisible()) {
            _this.setState({
              clicked: true
            }, function(){
              _this.loadFunction();
            });
          }
        });
      }
    }

    if(!SessionStore.loading) {
      if(this.state.url && !this.state.done) {
        if(!this.state.clicked) {
          return (
            <button
              className="btn btn--more"
              onClick={this.loadFunction}
              ref="button"
            >
              {this.props.text}
            </button>
          );
        } else {
          return (
            <span className="loader-bar">Loading…</span>
          );
        }
      }
    }

    return null;
  }
})

export default LoadMore;



// WEBPACK FOOTER //
// ./src/app/components/Common/LoadMore.js